<template>
      <v-container grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <div class="my-title">Логотип филиала VM Core Production - "Новая школа дизайна"</div>
      </v-flex>
    </v-layout>
      <v-layout class="justify-center">
      <v-flex xs12 sm6 md6>
        <iframe width="100%" height="315" src="https://www.youtube.com/embed/43aBL2k297c" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </v-flex>
    </v-layout>
      </v-container>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>
.my-title {
    font-family: 'Pacifico', cursive;
    font-size: 3rem;
    color: white;
    text-align: center;
    margin-top: 2rem;
    margin-bottom: 1rem;
  }
</style>